import React from 'react';
import { Briefcase, CircleHelp, HardHat } from 'lucide-react';

export const COLLAR_TILES = [
  { key: 'white', label: 'White Collar', Icon: Briefcase, tone: 'text-sky-700', tvTone: 'text-sky-300', ring: 'ring-sky-500' },
  { key: 'blue', label: 'Blue Collar', Icon: HardHat, tone: 'text-blue-800', tvTone: 'text-blue-300', ring: 'ring-blue-700' },
  { key: 'none', label: 'Collar not set', Icon: CircleHelp, tone: 'text-gray-500', tvTone: 'text-slate-300', ring: 'ring-gray-400' },
];

/** White / Blue / Not set split of a report's main number; click a tile to filter by it, click again for all. */
export const CollarTiles = ({ split, value = '', onPick, metric, sub, fmt = (v) => v, tv = false, testId = 'collar-tiles' }) => {
  if (!split) return null;
  return (
    <div className="grid grid-cols-3 gap-3" data-testid={testId}>
      {COLLAR_TILES.map(({ key, label, Icon, tone, tvTone, ring }) => {
        const s = split[key] || { staff: 0, value: 0 };
        const on = value === key;
        return (
          <button key={key} type="button" onClick={() => onPick?.(on ? '' : key)} disabled={!onPick} aria-pressed={on} data-testid={`${testId}-${key}`}
            className={`text-left rounded-xl p-3 transition-[box-shadow,transform] duration-150 enabled:hover:-translate-y-0.5 ${tv ? 'bg-slate-800' : 'bg-white shadow-sm'} ${on ? `ring-2 ${ring}` : ''}`}>
            <div className={`flex items-center gap-1.5 uppercase tracking-wide ${tv ? 'text-sm text-slate-400' : 'text-[11px] text-gray-500'}`}><Icon className="w-3.5 h-3.5" />{label}</div>
            <div className={`font-bold tabular-nums ${tv ? `text-4xl ${tvTone}` : `text-2xl ${tone}`}`} data-testid={`${testId}-${key}-value`}>{fmt(s.value)}</div>
            <div className={tv ? 'text-sm text-slate-400' : 'text-xs text-gray-500'} data-testid={`${testId}-${key}-sub`}>{metric}{sub ? ` · ${sub(s)}` : ''}</div>
          </button>
        );
      })}
    </div>
  );
};

export default CollarTiles;
